import "./App.css";
import ScrollToTop from "./components/ScrollToTop";
import { SidebarProvider } from "./context/SidebarContext";
import AllRoutes from "./routes/AllRoutes";

function App() {
  return (
    <div className="bg-white">
      <SidebarProvider>
        <ScrollToTop />
        <AllRoutes />
      </SidebarProvider>
    </div>
  );
}

export default App;
